import { routeAccess } from 'app/access';
import RequireAuth from 'app/components/RequireAuth';
import { lazy } from 'react';
import { Route } from 'react-router';

const Segment2OverviewRoute = lazy(() => import('./segment2/Segment2SearchRoute'));
const CreateSegment2Route = lazy(() => import('./segment2/CreateSegment2Route'));
const Segment2DetailsRoute = lazy(() => import('./segment2/Segment2DetailsRoute'));
const Segment3OverviewRoute = lazy(() => import('./segment3/Segment3SearchRoute'));
const CreateSegment3Route = lazy(() => import('./segment3/CreateSegment3Route'));
const Segment3DetailsRoute = lazy(() => import('./segment3/Segment3DetailsRoute'));
const Segment4OverviewRoute = lazy(() => import('./segment4/Segment4SearchRoute'));
const CreateSegment4Route = lazy(() => import('./segment4/CreateSegment4Route'));
const Segment4DetailsRoute = lazy(() => import('./segment4/Segment4DetailsRoute'));
const Segment5OverviewRoute = lazy(() => import('./segment5/Segment5SearchRoute'));
const CreateSegment5Route = lazy(() => import('./segment5/CreateSegment5Route'));
const Segment5DetailsRoute = lazy(() => import('./segment5/Segment5DetailsRoute'));
const Segment6OverviewRoute = lazy(() => import('./segment6/Segment6SearchRoute'));
const CreateSegment6Route = lazy(() => import('./segment6/CreateSegment6Route'));
const Segment6DetailsRoute = lazy(() => import('./segment6/Segment6DetailsRoute'));
const Segment7OverviewRoute = lazy(() => import('./segment7/Segment7SearchRoute'));
const CreateSegment7Route = lazy(() => import('./segment7/CreateSegment7Route'));
const Segment7DetailsRoute = lazy(() => import('./segment7/Segment7DetailsRoute'));

export default [
  <Route
    key="segment2"
    path="segment2"
    element={
      <RequireAuth {...routeAccess.accountCodePlan}>
        <Segment2OverviewRoute />
      </RequireAuth>
    }
  />,
  <Route
    key="segment2-new"
    path="segment2/new"
    element={
      <RequireAuth {...routeAccess.accountCodePlanCreate}>
        <CreateSegment2Route />
      </RequireAuth>
    }
  />,
  <Route
    key="segment2-details"
    path="segment2/:id"
    element={
      <RequireAuth {...routeAccess.accountCodePlan}>
        <Segment2DetailsRoute />
      </RequireAuth>
    }
  />,
  <Route
    key="segment3"
    path="segment3"
    element={
      <RequireAuth {...routeAccess.accountCodePlan}>
        <Segment3OverviewRoute />
      </RequireAuth>
    }
  />,
  <Route
    key="segment3-new"
    path="segment3/new"
    element={
      <RequireAuth {...routeAccess.accountCodePlanCreate}>
        <CreateSegment3Route />
      </RequireAuth>
    }
  />,
  <Route
    key="segment3-details"
    path="segment3/:id"
    element={
      <RequireAuth {...routeAccess.accountCodePlan}>
        <Segment3DetailsRoute />
      </RequireAuth>
    }
  />,
  <Route
    key="segment4"
    path="segment4"
    element={
      <RequireAuth {...routeAccess.accountCodePlan}>
        <Segment4OverviewRoute />
      </RequireAuth>
    }
  />,
  <Route
    key="segment4-new"
    path="segment4/new"
    element={
      <RequireAuth {...routeAccess.accountCodePlanCreate}>
        <CreateSegment4Route />
      </RequireAuth>
    }
  />,
  <Route
    key="segment4-details"
    path="segment4/:id"
    element={
      <RequireAuth {...routeAccess.accountCodePlan}>
        <Segment4DetailsRoute />
      </RequireAuth>
    }
  />,
  <Route
    key="segment5"
    path="segment5"
    element={
      <RequireAuth {...routeAccess.accountCodePlan}>
        <Segment5OverviewRoute />
      </RequireAuth>
    }
  />,
  <Route
    key="segment5-new"
    path="segment5/new"
    element={
      <RequireAuth {...routeAccess.accountCodePlanCreate}>
        <CreateSegment5Route />
      </RequireAuth>
    }
  />,
  <Route
    key="segment5-details"
    path="segment5/:id"
    element={
      <RequireAuth {...routeAccess.accountCodePlan}>
        <Segment5DetailsRoute />
      </RequireAuth>
    }
  />,
  <Route
    key="segment6"
    path="segment6"
    element={
      <RequireAuth {...routeAccess.accountCodePlan}>
        <Segment6OverviewRoute />
      </RequireAuth>
    }
  />,
  <Route
    key="segment6-new"
    path="segment6/new"
    element={
      <RequireAuth {...routeAccess.accountCodePlanCreate}>
        <CreateSegment6Route />
      </RequireAuth>
    }
  />,
  <Route
    key="segment6-details"
    path="segment6/:id"
    element={
      <RequireAuth {...routeAccess.accountCodePlan}>
        <Segment6DetailsRoute />
      </RequireAuth>
    }
  />,
  <Route
    key="segment7"
    path="segment7"
    element={
      <RequireAuth {...routeAccess.accountCodePlan}>
        <Segment7OverviewRoute />
      </RequireAuth>
    }
  />,
  <Route
    key="segment7-new"
    path="segment7/new"
    element={
      <RequireAuth {...routeAccess.accountCodePlanCreate}>
        <CreateSegment7Route />
      </RequireAuth>
    }
  />,
  <Route
    key="segment7-details"
    path="segment7/:id"
    element={
      <RequireAuth {...routeAccess.accountCodePlan}>
        <Segment7DetailsRoute />
      </RequireAuth>
    }
  />,
];
